import { Translation } from './constants';

export const de: Translation = {
	loginText: 'Rohstoffpreise à la carte',
	forgotYourPassword: 'Passwort vergessen?',
	signUp: 'Registrieren',
	eMail: 'E-Mail-Adresse',
	registered: 'Registriert',
	customerNr: 'Kunden-Nr.',
	freemium: 'Freemium',
	customer: 'Kunden',
	animateWidgetLine: 'Animierte Dashboard Widgets',
	showPartnerLinkLine: 'Partnerbereich in der Navigationsleiste anzeigen',
	animation: 'Animationen',
	personalize: 'Personalisierung',
	searchMaterialEtc: 'Suche nach Preisen',
	searchNewsEtc: 'Suche nach Nachrichten',
	noTendersSaved: 'Keine Ausschreibungen gespeichert',
	noEarlyProjectInfoSaved: 'Keine Projektfrühinformationen gespeichert',
	tendersAndMore: 'Ausschreibungen & mehr',
	frozen: 'Frozen',
	unfreeze: 'Unfreeze',
	freeze: 'Freeze',
	adminDownloadIntraday: 'Admin-Download (Intr.)',
	passwordConfirmation: 'Eine Passwortbestätigung',
	clickHereTo: 'Klicken Sie hier, um sich zu',
	forgotPasswordWaitMessage:
		'Wenn Ihre E-Mail-Adresse bekannt ist, erhalten Sie in den nächsten Minuten eine E-Mail von uns. Sollten Sie nach 5 Minuten keine E-Mail erhalten haben, prüfen Sie bitte auch Ihren Spam-Ordner. Alternativ können Sie sich auch an den Kundenservice wenden',
	oldPasswordIsRequired: 'Altes Passwort ist erforderlich',
	passwordMatch: 'Neues Passwort und neues Passwort bestätigen stimmen nicht überein!',
	spaceNotExists: 'Raum sollte nicht existieren',
	passwordCriteria: 'Ihr Passwort muss folgende Kriterien erfüllen:',
	oneSpecialChar: 'Mindestens ein Sonderzeichen',
	oneNumberValidation: 'Mindestens eine Zahl',
	oneUppercaseOneLowercase: 'Mindestens einen Groß- und Kleinbuchstaben',
	atLeast8Characters: 'Mindestens 8 und maximal 24 Zeichen lang',
	matfoxxSettings: 'Matfoxx-Einstellungen',
	matfoxxNotifications: 'Benachrichtigungen',
	matfoxxNotificationOff: 'Aus',
	matfoxxNotificationOn: 'An',
	notificationPeriod: 'Benachrichtigungsintervall',
	notificationAutomatically: 'Automatisch',
	until: 'Bis',
	filterNotifications: 'Benachrichtigungsfilter',
	quoteOTheDay: 'Zitat des Tages',
	matflixxOffers: 'Matflixx-Angebote',
	updateGroup: 'Gruppe aktualisieren',
	subGroup: 'Untergruppe',
	deleteCourseList: 'Sind Sie sicher, dass Sie dieses Objekt löschen möchten?',
	createGroup: 'Daten verwalten',
	editModelParameters: 'Modellparameter bearbeiten',
	addToCostModel: 'Zum Kostenmodell hinzufügen',
	matflixxModals: 'Matflixx-Modelle',
	addMatflixxModals: 'Matflixx-Modelle hinzufügen',
	customizeCostModel: 'Kostenmodell anpassen',
	sinceOneQuater: 'Seit 1 Quartal',
	sinceOneYear: 'Seit 1 Jahr',
	sinceOneMonth: 'Seit 1 Monat',
	priceDriver: 'Preistreiber',
	shares: 'Anteile',
	share: 'Teilen',
	updateOnDashboard: 'Auf Dashboard aktualisieren',
	myCostModel: 'Mein Kostenmodell',
	dashboard: 'Dashboard',
	myDashboard: 'Mein Dashboard',
	noUserFound: 'Keine Benutzerdaten gefunden',
	customize: 'Anpassen',
	favorites: 'Favoriten',
	myData: 'Meine Daten',
	myNewsAndForecast: 'Meine Nachrichten und Prognosen',
	designation: 'Bezeichnung',
	news: 'Nachrichten',
	update: 'Aktualisierung',
	delete: 'Löschen',
	edit: 'Bearbeiten',
	date: 'Datum',
	price: 'Preis',
	change: '%-Veränderung',
	convert: 'Umrechnen',
	addToDashboard: 'Zum Dashboard hinzufügen',
	myShortcut: 'Meine Shortcuts',
	addShortcut: 'Neuen Shortcut hinzufügen',
	pleseSelectFieldMessage: 'Bitte füllen Sie dieses Feld aus',
	targetUrl: 'Ziel-URL',
	enterValidUrlAddress: 'Gültige URL-Adresse eingeben',
	urlForLogoPriview: 'URL für Logo oder Vorschau (optional)',
	rawMaterials: 'Rohstoffe',
	selectedMaterials: 'Ausgewählte Rohstoffe',
	selectedNews: 'Ausgewählte Nachrichten',
	addWidgetToDashboard: 'Widget zum Dashboard hinzufügen',
	submit: 'Speichern',
	showAll: 'Alle anzeigen',
	latestNews: 'Neueste Nachrichten',
	addWidget: 'Widget hinzufügen',
	allSectors: 'Alle Sektoren',
	collapsePanel: 'Panel ausblenden',
	noCourseListing: 'Keine Kurslisten',
	noMaterialFound: 'Keine Kurse gefunden',
	exportCorseListAsExcel: 'Daten als Excel exportieren',
	advanceSearchForCourses: 'Erweitere Suche nach Kursen',
	seek: 'Suche',
	searchPatterns: 'Bitte einen Suchbegriff eingeben!',
	advanceSearchPlaceHolder: 'Min. 3 Zeichen, wie z.B. "Strom"',
	duration: 'Laufzeit',
	doNotMetter: 'Keine Relevanz',
	withoutDueDate: 'Ohne Fälligkeit',
	withoutFutures: 'Ohne Futures',
	futurePerptualContracsOnly: 'Nur Future-Endlos-Kontrakte',
	futureWithoutEndlessContract: 'Futures ohne Endlos-Kontrakte',
	back: 'Zurück',
	materials: 'Materialien',
	addFilterToDashboard: 'Filter zum Dashboard hinzufügen',
	chooseDateRange: 'Datumsbereich wählen',
	cancel: 'Abbrechen',
	searchNews: 'Nachrichten durchsuchen',
	searchNewsMaterialEtc: 'Suche nach Nachrichten, Preisen, etc.',
	all: 'Alle',
	noEntriesFound: 'Keine Einträge gefunden',
	tryUsingDiffKeyword: 'Versuchen Sie ein anderes Schlagwort',
	more: 'Mehr...',
	notification: 'Benachrichtigung',
	profile: 'Profil',
	logout: 'Abmelden',
	login: 'Anmelden',
	emailAddress: 'E-Mail-Adresse',
	password: 'Passwort',
	exportHistoryAsCSV: 'Als CSV exportieren',
	exportDataAsExcel: 'Als Excel exportieren',
	add: 'Hinzufügen',
	maturityOverview: 'Laufzeiten-Übersicht',
	exportPriceAsExcel: 'Kurse als Excel exportieren',
	addWidgetToScreeen: 'Zum Dashboard hinzufügen',
	setUpPriceAlert: 'Preis-Alert einrichten',
	addChartToDashboard: 'Chart zum Dashboard hinzufügen',
	courseListings: 'Kurslisten',
	renameCourseList: 'Kursliste umbenennen',
	rename: 'Umbenennen',
	extinguish: 'Löschen',
	newsFilterTags: 'Nachrichten Filter / Schlagwörter',
	alerts: 'Alerts',
	notifyAtTime: 'Benachrichtigen um ... Uhrzeit (optional)',
	noteMessageForAllKeywordAppears: 'Hinweis: Die Benachrichtigung erfolgt nur, wenn alle Schlagwörter in einer Nachricht vorkommen!',
	addNews: 'Neuer Alert',
	currnetCourse: 'Aktueller Kurs',
	reportIf: 'Melden, wenn',
	courseExceeded: 'Kurs überschritten',
	courseUndershot: 'Kurs unterschritten',
	absPerDeviationExceeded: 'abs. proz. Abweichung d.K. überschritten',
	comparativeValue: 'Vergleichswert',
	dateOfExpiry: 'Auslaufdatum',
	addCourseAlert: 'Kurs-Alert hinzufügen',
	messageAlerts: 'Mitteilungsalarm',
	keywords: 'Suchwörter',
	exmpleEleGas: 'z.B. "Strom"',
	forecasts: 'Prognosen',
	pdfModule: 'Meine PDFs',
	name: 'Name',
	noNewsHeading: 'Keine Nachrichtenrubriken...',
	createNewPriceList: 'Eine neue Preisliste erstellen',
	addAnotherOneLanguage: 'Eine weitere Sprache hinzufügen',
	view: 'Anzeigen',
	uploadFile: 'Datei hochladen',
	maturity: 'Fälligkeit',
	symbol: 'Symbol',
	visible: 'Sichtbar',
	notVisible: 'Nicht sichtbar',
	pricesTime: 'Kurszeit',
	selectAll: 'Alles auswählen',
	hideSelected: 'Ausgewählte ausblenden',
	deleteSelected: 'Ausgewählte löschen',
	editUserData: 'Benutzerdaten bearbeiten',
	save: 'Speichern',
	generalInfo: 'Allgemeine Informationen',
	salutation: 'Anrede',
	mr: 'Herr',
	ms: 'Frau',
	surname: 'Nachname',
	company: 'Unternehmen',
	contacts: 'Kontakte',
	phoneNumber: 'Rufnummer',
	email: 'E-mail',
	permissionData: 'Berechtigungen',
	status: 'Status',
	active: 'Aktiv',
	admin: 'Admin',
	inactive: 'Inaktiv',
	validUntill: 'Gültig bis',
	apiInterfaceActive: 'API-Schnittstelle aktiv',
	apiKey: 'API-Key',
	comment: 'Kommentar',
	superAdminMessage: 'Super-Admin',
	// , d.h. darf Admins und besondere Tabellen ändern.',
	adminMessage: 'User-Admin',
	// , d.h. darf Benutzer und Benutzerrechte ändern, sowie alles was Bearbeiter/Redakteur dürfen.',
	allMaterials: 'Alle Materialien',
	myMaterials: 'Meine Materialien',
	search: 'Suche',
	saveMessage: 'Gespeicherte Nachrichten',
	constModels: 'Kostenmodelle',
	courses: 'Kurs',
	dataProcessorMessage: 'Datenbearbeiter',
	// , d.h. berechtigt, Kurse, Historien und MBI-Kurslisten zu ändern',
	editorMessage: 'Redakteur',
	// , d.h. darf Nachrichten ändern und löschen',
	API: 'API',
	statistics: 'Statistiken',
	validity: 'Gültigkeit',
	markant: 'Markant',
	manageData: 'Daten verwalten',
	permission: 'Berechtigungen',
	ownDataUpload: 'Eigene Daten hochladen',
	invisible: 'Unsichtbar',
	whiteLabelAdmin: 'Whitelabel-Benutzer',
	groupName: 'Gruppenname',
	files: 'Dateien',
	addFile: 'Datei hinzufügen',
	dragAndDropToUploadFile: 'Drag & Drop zum Hochladen von Dateien',
	uploaded: 'Hochgeladen',
	timeLimit: 'Zeitlimit',
	occurred: 'Aufgetreten',
	deactive: 'Deaktivieren',
	isin: 'ISIN',
	exchange: 'Börsenname',
	dataProvider: 'Datenlieferant',
	source: 'Quelle',
	cpCustomer: 'CP Kunde',
	courseTime: 'Kurszeit',
	country: 'Land',
	currency: 'Währung',
	pleaseSelectACategory: 'Bitte wählen Sie eine Kategorie aus',
	chooseCountry: 'Land wählen',
	runTime: 'Laufzeit',
	chooseCurrency: 'Währung wählen',
	advanceSearchfForPrice: 'Erweitere Suche nach Kursen',
	advanceSearchTableText:
		'Zu Ihrer Suche sind noch mehr passende Kurse vorhanden. Blättern Sie vorwärts. Insgesamt werden jedoch maximal 200 Ergebnisse angezeigt.',
	advanceSearchTableDescription:
		'Geben Sie mehr Suchwörter ein, um das Ergebnis zu verfeinern und die Suche einzuschränken. Nutzen Sie auch Abkürzungen oder DIN / AISI Codes. Variieren Sie zwischen der deutschen und englischen Bezeichnung. Oder stellen Sie Wörtern ein Minus voran, z.B. -Deutschland',
	tip: 'Tipp',
	line: 'Linien',
	area: 'Flächen',
	candle: 'Kerzen',
	chartType: 'Charttyp',
	indicators: 'Indikatoren',
	span: 'Spanne',
	addToPrice: ' Zu meinen Materialien hinzufügen',
	currentPrice: 'Derzeitiger Preis',
	alertCurrency: 'Währung',
	addedToDashboard: 'Zum Dashboard hinzugefügt!',
	updatedToDashboard: 'Auf Dashboard aktualisiert!',
	exportData: 'Datenexport',
	selectFileFormat: 'Dateityp auswählen',
	users: 'Benutzer',
	data: 'Daten',
	whiteLabel: 'White Label',
	matfoxx: 'Matfoxx',
	myMaterialsEmptyTitle: 'Diese Kursliste ist leer!',
	myMaterialEmptyDescription:
		'Um Materialien oder Preise zu dieser Kursliste hinzuzufügen, bitte ein Material/Preis über die Suchfunktion oder über "Alle Materialien" öffnen und dann auf "Zu einer Kursliste hinzufügen" klicken. Dann den Namen dieser Kursliste auswählen.',
	advancedSearchResult: 'Die Suche liefert keine Ergebnisse.',
	profileData: 'Profil & Daten',
	profileInfo: 'Profil-Information',

	profileSaveChanges: 'Änderungen speichern',
	profilePhoto: 'Profilfoto',
	profileAddFile: 'Datei hinzufügen',
	profileDragandDrop: 'oder per Drag & Drop hierher ziehen',
	profileSavePhotos: 'Foto speichern',
	profileDeletePhotos: 'Foto löschen',
	profileGeneralData: 'Allgemeine Daten',
	profileCurrentEmail: 'Aktuelle E-Mail-Adresse',
	profileChangePassword: 'Passwort ändern',
	advancedSearchTip:
		'Tipp: Geben Sie mehr Suchwörter ein, um das Ergebnis zu verfeinern und die Suche einzuschränken. Nutzen Sie auch Abkürzungen oder DIN / AISI Codes. Variieren Sie zwischen der deutschen und englischen Bezeichnung. Oder stellen Sie Wörtern ein Minus voran, z.B. -Deutschland, um Preisdaten auszuschließen, die dieses Wort im Namen haben.',
	adminDownloadHistory: 'Admin-Download (Hist.)',
	addToMbiList: 'Zu einer MBI-Kursliste hinzufügen',
	assignMaterialToUser: 'Material einem Benutzer zuweisen',
	dataEditing: 'Datenbearbeitung',
	addCourseToCourseList: 'Kurs zu einer Kursliste hinzufügen',
	searchUsers: 'Benutzer suchen',
	general: 'Allgemein',
	registerNow: 'Registrieren',
	city: 'Stadt',
	position: 'Position',
	postcode: 'Postleitzahl',
	required: 'Erforderlich',
	firstname: 'Vorname',
	download: 'Download',
	imprint: 'Impressum',
	settings: 'Einstellungen',
	abort: 'Abbrechen',
	takeOver: 'Übernehmen',
	removed: 'Entfernen',
	days: 'Tage',
	setPeriod: 'Zeitraum festlegen',
	onboardSecondTitle: 'Welche Darstellungsweise bevorzugen Sie?',
	createPassword: 'Passwort erstellen',
	futures: 'Zukunft',
	masterExportExcel: 'Stammdaten-Download',
	enterValuesGreaterThan: 'Eingabe Wert größer als',
	enterValuesLessThan: 'Eingabe Wert kleiner als',
	comparisonValues: 'Vergleichswert muss zwischen 0 - 100 liegen',
	comparisonValueGreaterThanZero: 'Vergleichswert muss größer als Null sein',
	numberIsTooBig: 'Nummer ist zu groß',
	courseDifference: 'Abs. proz. Abweichung d. K. überschritten',
	selectFromTheDropDown: 'Bitte aus dem Dropdown-Menü auswählen',
	title: 'Bezeichnung',
	url: 'URL',
	urlplaceholder: 'https://...',
	registrationValidationType: 'Unzulässiger Typ',
	addShortCutDeleteLink: 'Link löschen',
	comparativeSearchPlaceholder: 'Vergleichswert',
	month: 'Monat',
	months: 'Monate',
	year: 'Jahr',
	custom: 'Benutzerdefiniert',
	emptyChartMessage: 'Daten konnten leider nicht geladen werden, weil der letzte Kurs älter als ein Jahr ist!',
	ema: 'Exponentieller gleitender Durchschnitt (EMA)',
	sma: 'Einfacher gleitender Durchschnitt (SMA)',
	bb: 'Bollinger Bänder (BB)',
	tma: 'Triangularer gleitender Durchschnitt (TMA)',
	wma: 'Gewichteter gleitender Durchschnitt (WMA)',
	atr: 'Wahre durchschnittliche Schwankungsbreite (ATR)',
	rsi: 'Relative Stärke Index (RSI)',
	macd: 'Konvergenter / Divergenter gleitender Durchschnitt (MACD)',
	sto: 'Stochastischer Oszillator (STO)',
	lowDataChartMessage: 'Keine oder zu wenig Kurse!',
	choose: 'wählen',
	noAlertFound: 'Keine Alerts gefunden',
	loadingChartData: 'Chartdaten werden geladen...',
	deleteDashboardWidget: 'Sicher, dass Sie dieses Widget löschen möchten?',
	positiveDifference: '% positive Abweichung',
	negativeDifference: '% negative Abweichung',
	updateChartToDashboard: 'Chart auf Dashboard aktualisieren',
	daily: 'Täglich',
	weekly: 'Wöchentlich',
	monthly: 'Monatlich',
	updateToDashBoard: 'Auf Dashboard aktualisieren',
	addMaterials: 'Materialien Hinzufügen',
	addNewsAndForecast: 'Nachrichten und Prognosen hinzufügen',
	unlimited: 'Unbegrenzt',
	markAllAsRead: 'Markiere alle als gelesen',
	otherChanges: 'Andere Änderungen',
	materialAlert: 'Kurs-Alerts',
	newslAlert: 'Nachrichten-Alerts',
	actual: 'Aktuell',
	hist: 'Historisch',
	high: 'Hoch',
	low: 'Tief',
	histDate: 'Hist. Datum',
	unit: 'Einheit',
	kurszeit: 'Kurszeit',
	dueDate: 'Fälligkeit',
	mbiListPlaceHolder: 'Bez. eingeben',
	isRequired: 'ist erforderlich!',
	confirmLogout: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
	yes: 'Ja',
	no: 'Nein',
	faq: 'FAQ',
	almostThere: 'Fast fertig!',
	weNeedInfo: 'Wir brauchen nur noch ein paar Informationen.',
	bis: 'Bis',
	von: 'Von',
	protocol: 'Protokoll',
	categoryIncludeMessage: 'Dieses Material ist in folgenden Kurslisten enthalten:',
	userIsAdminMessage: 'Der Benutzer {{userName}} ist ein Administrator und kann alle Daten sehen, weshalb hier nichts angezeigt wird',
	editNews: 'Nachrichten bearbeiten',
	deleteNews: 'Nachrichten löschen',
	adminPriceDownload: 'Admin-Kurs-Download',
	userId: 'Benutzer-ID',
	uploadedBy: 'Hochgeladen von',
	fileName: 'Dateiname',
	inserted: 'Eingefügt',
	updated: 'Aktualisiert',
	processes: 'Verarbeitet',
	mistake: 'Fehler',
	noGroup: 'Keine Gruppe',
	enterEmail: 'Bitte eine korrekte Email-Adresse angeben',
	forgotPasswordNote:
		'Wenn Sie ein neues Passwort anfordern, erhalten Sie von uns eine E-Mail mit einem Link zum Einrichten eines neuen Passworts.',
	requestNewPassword: 'Neues Passwort anfordern',
	alreadyRegistered: 'Wenn Sie bereits registriert sind, melden Sie sich bitte hier an',
	here: 'hier',
	notSubscribeYet: 'Sie sind noch kein Abonnent? Dann',
	register: 'registrieren',
	now: 'jetzt',
	passwordForgotten: 'Passwort vergessen',
	testForFree: 'und testen Sie Matflixx kostenlos.',
	noSavedNewsFound: 'Sie haben keine Nachrichten markiert...',
	takeOverAccount: 'Übernehmen',
	takeOverFirstMessage:
		'Sie haben dieses Benutzerkonto übernommen. Änderungen, die Sie vornehmen, wirken sich tatsächlich auf das Kundenkonto aus. Klicken Sie',
	takeOverSecondMessage: ', um zu Ihrem Konto zurückzukehren.',
	saveChanges: 'Änderungen speichern',
	discard: 'Verwerfen',
	lastName: 'Nachname',
	removeFromDashboard: 'Vom Dashboard entfernt',
	newsSections: 'Nachrichtenrubriken...',
	itemChoosen: 'Elemente gewählt.',
	group: 'Gruppe',
	authorized: 'Berechtigung',
	mainCourse: 'Hauptkurs',
	alertWhen: 'Melden, wenn',
	entered: 'Eingetreten',
	newsFilterKeyWords: 'Nachrichtenfilter / Schlagwörter',
	deleteAlertMessage: 'Möchten Sie die Kurs-Überwachnung für {{alert}} löschen?',
	visibility: 'Sichtbarkeit',
	hidden: 'Verborgen',
	addPartnersLink: 'Partnerlink hinzufügen',
	assign: 'Zuweisen',
	create: 'Erstellen...',
	savedNews: 'Nachricht gespeichert.',
	shortcutCreated: 'Shortcut hinzugefügt.',
	shortcutUpdated: 'Änderungen gespeichert.',
	shortcutDeleted: 'Shortcut entfernt.',
	widgetSwiped: 'Die Elementenanordnung wurde angepasst.',
	grantPermissionToUser: 'Die Benutzerrechte wurden aktualisiert!',
	deleteNewsArticle: 'Artikel wurde gelöscht.',
	deleteFromCourseList: 'Eintrag aus der Kursliste entfernt!',
	addedToList: 'Zur Liste hinzugefügt!',
	forgotPassword: 'Passwort vergessen',
	priceListIsEmpty: 'Diese Kursliste ist leer!',
	emptyPriceListMessage:
		'Um Materialien oder Preise zu dieser Kursliste hinzuzufügen, bitte ein Material/Preis über die Suchfunktion oder über Alle Materialien öffnen und dann auf "Zu einer Kursliste hinzufügen" klicken. Dann den Namen dieser Kursliste auswählen.',
	deleteNewsPopupMessage: 'Sind Sie sicher, dass Sie den Artikel löschen möchten?',
	validUrlErrorMessage: 'Bitte gültige URL eingeben',
	addInformation: 'Information hinzufügen',
	enterNote: 'Notiz eingeben',
	choosePriority: 'Priorität wählen',
	normal: 'Normal',
	critical: 'Kritisch',
	editInformation: 'Information bearbeiten',
	authorizationElement: 'Autorisierungselement',
	userList: 'Benutzerliste',
	masterData: 'Stammdaten',
	backpack: 'Rucksack',
	createNewBackpack: 'Erstellen Sie einen neuen Rucksack',
	editBackpack: 'Rucksack bearbeiten',
	downloadMasterData: 'Stammdaten-Download',
	comparisionValueShouldNotBeEmpty: 'Der Vergleichswert darf nicht leer sein',
	reset: 'Zurücksetzen',
	whiteLabelFormTitle: 'Ändern Sie die Farbe der Benutzeroberfläche',
	colors: 'Farben',
	courseListNameHasBeenSaved: 'Kurslistename wurde gespeichert!',
	courseListDeleted: 'Kursliste gelöscht!',
	noCurrentData: 'Keine aktuellen Daten',
	maximumLimitReached: 'Limit erreicht. Einige Elemente konnten nicht zum Dashboard hinzugefügt werden',
	noNewsArticleFound: 'Keine Nachrichten gefunden...',
	additionalInfo: 'Zusatzinfo',
	chartUpdateDaily: 'Täglich',
	chartUpdateWeekly: 'Wöchentlich',
	chartUpdateMonthly: 'Monatlich',
	listName: 'Listenname',
	partnerLinks: 'Partner-Links',
	addAlertDropDownPlaceholder: 'Auswählen',
	glossary: 'Glossar',
	normalization: 'Normalisieren',
	myModels: 'Meine Modelle',
	exportAsExcel: 'Daten als Excel exportieren',
	exportAsCSV: 'Daten als CSV exportieren',
	createNewCostModel: 'Neues Kostenmodell erstellen',
	noDataFound: 'Keine Daten gefunden',
	modalName: 'Modellname',
	sectors: 'Sektoren',
	makeThisModelVisible: 'Dieses Modell sichtbar machen',
	ingridients: 'Bestandteile',
	number: 'Nr.',
	componentName: 'Komponentenname',
	amount: 'Menge',
	ratio: 'Anteil',
	total: 'Gesamt',
	saveAsDraft: 'Als Entwurf speichern',
	createCostModel: 'Kostenmodell erstellen',
	upload: 'Hochladen',
	listofOffers: 'Angebotsliste',
	addNewsDashboard: 'Nachrichten hinzufügen',
	matfoxxOffersFormHeader: 'Angezeigter Text, Handlung, Dauer',
	fileHasBeenUploaded: 'Datei wurde hochgeladen',
	enterTheOfferText: 'Angebotstext einfügen',
	enterValue: 'Wert eingeben',
	text: 'Text',
	link: 'Verknüpfung',
	jokes: 'Witze',
	enterJoke: 'Einen Witz eingeben',
	listOfJokes: 'Witzliste',
	jokeOfTheDay: 'Witz des Tages',
	offerOfTheDay: 'Angebot des Tages',
	heading: 'Überschrift',
	entry: 'Eintrag',
	listOfAnnouncements: 'Liste der Ankündigungen',
	loadMore: 'Mehr laden',
	allDocuments: 'Alle Dokumente',
	editPrice: 'Preis bearbeiten',
	howWouldYouLikeToProceed: 'Wie möchten Sie fortfahren?',
	generateDashBoardAuomatic: 'Dashboard automatisch erstellen',
	customerServiceAssistence: 'Kundenservice kontaktieren',
	createYourOwnDashboard: 'Eigenes Dashboard erstellen',
	balancedDashboard: 'Ausgeglichenes Dashboard',
	graphicalDashboard: 'Graphisches Dashboard',
	analyticalDashboard: 'Analytisches Dashboard',
	next: 'Weiter',
	addNewForecast: 'Eine neue Prognose hinzufügen',
	addNewPdfModule: 'Eine neue PDF hinzufügen',
	pleaseUploadFileFirst: 'Bitte zunächst Datei hochladen*',
	oldPassword: 'Altes Passwort',
	newPassword: 'Neues Passwort',
	confirmNewPassword: 'Neues Passwort bestätigen',
	passwordChanged: 'Passwort geändert',
	forgotPasswordMailSendMessage: 'Wir senden Ihnen innerhalb weniger Minuten eine E-Mail.',
	sector: 'Sektor',
	category: 'Kategorie',
	imageSources: 'Bildquellen',
	chartUpdateQuarterly: 'Quartalsweise',
	forecastDelete: 'Prognose gelöscht!',
	pdfModuleDelete: 'PDF gelöscht!',
	day: 'Tag',
	week: 'Woche',
	prices: 'Preise',
	logarithmicYAxis: 'Logarithmische Y-Achse',
	informations: 'Informationen',
	frequency: 'Frequenz',
	stockExchange: 'Börse',
	dataAvailability: 'Datenverfügbarkeit',
	addInfo: 'Zus. Informationen',
	addedOn: 'Hinzugefügt am',
	endedOn: 'Eingestellt am',
	graphicDownload: 'Grafik exportieren',
	adminDownloadForecast: 'Admin download (Forecast)',
	adminDownloadPdfModule: 'Admin download (PDF)',
	default: 'Standard',
	inventoryChart: 'Lagerbestand',
	forwardCurve: 'Forwardkurve',
	uploadActiveSVG: 'Upload aktives SVG-Icon',
	uploadInActiveSVG: 'Upload inaktives SVG-Icon',
	tenders: 'Ausschreibungen',
	saveTenders: 'Gespeicherte Ausschreibungen',
	projectEarlyInformation: 'Projektfrühinformationen',
	countries: 'Länder',
	noTenderArticleFound: 'Keine Ausschreibungen gefunden',
	created: 'Erscheinungsdatum',
	validFrom: 'Gültig von',
	validTo: 'Gültig bis',
	deadLine: 'Deadline',
	financing: 'Finanzierung',
	gtaiId: 'GTAI-ID',
	projectName: 'Betreff',
	referenceNr: 'Referenznummer',
	latestTenders: 'Neueste Ausschreibungen',
	tenderAlerts: 'Ausschreibungen-Alerts',
	tenderFilterKeywords: 'Ausschreibung Filter / Schlagwörter',
	attachment: 'Anhänge',
	noSavedTenders: 'Sie haben keine Ausschreibungen gespeichert',
	chartSettings: 'Chart-Einstellungen',
	left: 'Links',
	right: 'Rechts',
	color: 'Farbe',
	indicator: 'Indikator',
	history: 'Historie',
	axis: 'Achse',
	short: 'Kurz',
	long: 'Lang',
	advancedSettings: 'Erweiterte Einstellungen',
	signal: 'Signal',
	duplicateChartTooltipMessage:
		'Dupliziert den Kurs, um historische Vergleiche im Jahreszeitraum oder Vergleiche in verschiedenen Währungen mit dem bereits ausgewählten Material/Datensatz durchzuführen.	',
	defaultTooltipMessage: 'Charting der Preisdaten',
	indicatorTooltipMessage: 'Auswahl der anzuwendenden Indikatoren. Es können mehrere Indikatoren gleichzeitig angewendet werden.',
	axisTooltipMessage: 'Position der Y-Achse',
	historyTooltipMessage: 'Auswahl der Historie nach Jahr',
	emaToolTipMessage: 'Durchschnittspreis eines Vermögenswerts, neue und aktuelle Daten/Preise haben größeres Gewicht.',
	smaToolTipMessage: 'Durchschnittspreis eines Vermögenswerts/Wertpapiers über einen bestimmten Zeitraum.',
	stoToolTipMessage: 'Ein Schlusskurs eines Wertpapiers wird mit einer Spanne seiner Kurse über einen bestimmten Zeitraum verglichen.',
	macdToolTipMessage: 'Ein Indikator zum Verständnis der Dynamik und Richtungsstärke eines Wertpapiers.',
	rsiToolTipMessage: 'Misst die Geschwindigkeit und Veränderung von Kursbewegungen.',
	bbToolTipMessage: 'Instrument der technischen Analyse.',
	tmaToolTipMessage: 'Der Durchschnitt des SMA. Reagiert nicht schnell auf volatile Marktbedingungen.',
	wmaToolTipMessage: 'Weist den aktuellen Datenpunkten ein größeres Gewicht zu.',
	atrToolTipMessage: 'Wird zur Messung der Kursbewegung eines Wertpapiers verwendet und basiert auf absoluten Werten.',
	changeToolTipMessage: 'Charting der Veränderung zum vorherigen Datenpunkt',
	LogarithmicYAxisTooltipMessage: 'Erlaubt die besser Darstellung von hohen Beträgen',
	numberTableHeader: 'Kursdaten',
	shortCustom: 'benutzerdef.',
	value: 'Wert',
	mustBeNumber: 'muss eine Zahl sein',
	exportFormat: 'Exportformat',
	grouping: 'Gruppierung',
	sorting: 'Sortierung',
	allData: 'Alle Daten',
	intraday: 'Intraday',
	yearly: 'Jährlich',
	chartUpdateYearly: 'Jährlich',
	standard: 'Standard',
	advanced: 'Fortgeschritten',
	ascending: 'Aufsteigend',
	descending: 'Absteigend',
	standardInfo: 'Enthält Preisdaten und Chart',
	advancedInfo: 'Standardexport erweitert um weitere Daten (falls verfügbar), wie prozentuale Veränderung und Forwards',
	dailyInfo: 'Export der täglichen Datenpunkte bzw. der Schlusskurse bei Intraday-Preisen',
	intradayInfo: 'Export aller Preisdaten innerhalb eines Handelstages',
	weeklyInfo: 'Export der wöchentlichen Datenpunkte bzw. der Wochendurchschnitte der verfügbaren Daten',
	monthlyInfo: 'Export der monatlichen Datenpunkte bzw. der Monatsdurchschnitte der verfügbaren Daten',
	ascendingInfo: 'Sortierung vom ältesten zum neusten Datenpunkt',
	descendingInfo: 'Sortierung vom neusten zum ältesten Datenpunkt',
	bar: 'Balken',
	barChartErrorMessage: 'Prozentuale Veränderung nur im Liniendiagramm sichtbar',
	barChartNumberValidationMessage: 'Das Balkendiagram unterstützt nur bis zu 3 Vergleichspreise',
	generatingChartImages: 'Chart-Abbildungen werden erzeugt...',
	intraDayInfo: 'Export aller Preisdaten innerhalb eines Handelstages',
	years: 'Jahre',
	none: 'Keine',
	dataNotIncludedInSubscription: 'Dieser Kurs ist aktuell nicht in Ihrem Abonnement enthalten.',
	pleaseSelectAllHistoryDropdown: 'Historien können nur mit anderen Historien verglichen werden.',
	noEnoughDataToPlot: 'Zu wenig Daten für grafische Darstellung.',
	createNewGroup: 'Neue Gruppe erstellen',
	groupManagement: 'Gruppenverwaltung',
	addNewGroup: 'Neue Gruppe hinzufügen',
	promotionCode: 'Aktionscode',
	selectUser: 'Nutzer auswählen',
	selectBackpack: 'Rucksack auswählen',
	selectWhiteLabel: 'Whitelabel auswählen',
	groups: 'Gruppen',
	editGroup: 'Gruppenverwaltung',
	customMailCommunication: 'Individuelle Mailkommunikation',
	adjustMailTemplate: 'Mailtemplates anpassen',
	chooseUser: 'Nutzer auswählen',
	fileUploadSuccessMessage: 'Datenupload erfolgreich',
	noWhiteLabelFoundErrorMessage: 'Kein Whitelabel gefunden! Bitte klicken sie auf "+", um ein neues zu erstellen.',
	registration: 'Registrierung',
	projectAlerts: 'Projekt-Alerts',
	copyToClipboard: 'In Zwischenablage kopiert',
	somethingWentWrong: 'Etwas ist schief gelaufen :confused:',
	phone: 'Telefon',
	foreignTradeNews: 'Außenwirtschafts-Nachrichten',
	financers: 'Finanzierer',
	deleteUser: 'Benutzer löschen',
	deleteUserMessage: 'Um einen Benutzer zu löschen, geben Sie "DELETE" ein',
	deleteMyMaterialConfirmationMessage: 'Sind Sie sicher, dass Sie den Kurs entfernen wollen?',
	deleteMyMaterialListEntriesConfirmationMessage: 'Sind Sie sicher, dass Sie die Liste löschen wollen?',
	groupName50CharacterValidation: 'Gruppenname darf höchstens 50 Zeichen haben',
	groupNameWhiteSpaceValidationMessage: 'Der Gruppenname darf nicht mehr als ein Leerzeichen zwischen den Wörtern enthalten',
	userDashboard: 'Benutzer Dashboards',
	dashboardAssignSuccessfully: 'Dashboard erfolgreich zugewiesen!',
	myMaterialListTransferredSuccessfully: '"Meine Materialien"-Liste erfolgreich übertragen!',
	transfer: 'Übertragen',
	acceptAtmax10Numbers: 'Maximal 10 Nummern akzeptiert',
	firstNameCharacterLengthValidation: 'Vorname darf höchstens 30 Zeichen lang sein',
	lastNameCharacterLengthValidation: 'Nachname darf höchstens 30 Zeichen lang sein',
	germanNameCharacterLengthValidation: 'Der deutsche Name darf höchstens 50 Zeichen lang sein.',
	englishNameCharacterLengthValidation: 'Der englische Name darf höchstens 50 Zeichen lang sein.',
	reports: 'Meldungen',
	allReports: 'Alle Meldungen',
	matflixxForecast: 'Matflixx Prognosen',
	matflixxPdfModule: 'Matflixx PDFs',
	clearAll: 'Auswahl aufheben',
	moveWidgetHere: 'Widget hierhin verschieben',
	deleteBackPackMessage: 'Um einen Rucksack zu löschen, geben Sie "DELETE" ein',
	inActivityMessage: 'Sie wurden aufgrund von Inaktivität ausgeloggt. Bitte loggen Sie sich erneut ein.',
	otherDeviceLoginMessage:
		'Es scheint als verwenden Sie Matflixx auf einem anderen Gerät. Für weitere Informationen kontaktieren Sie bitte den Kundenservice.',
	allForecasts: 'Alle Prognosen',
	allPdfModule: 'Alle PDFs',
	matflixxSectors: 'Matflixx Sektoren',
	imageValidationMessage: 'Die Datei ist zu groß. Bitte wählen Sie einen Anhang, der kleiner als 1 MB ist.',
	imageFormateValidationMessage: 'Nicht unterstütztes Dateiformat. Es werden nur die Formate JPEG, JPG und PNG unterstützt.',
	germanName: 'Deutscher Name',
	englishName: 'Englischer Name',
	activeIcon: 'Aktives Icon',
	inActiveIcon: 'Inaktives Icon',
	customMaterialStructure: 'Benutzerdefinierte Material-Struktur',
	customNewsStructures: 'Benutzerdefinierte Nachrichten-Struktur',
	customForecastStructure: 'Benutzerdefinierte Forecast-Struktur',
	customPdfModuleStructure: 'Benutzerdefinierte PDF-Struktur',
	activePlusOriginal: 'Aktiv (+zeige Original)',
	hideAll: 'Alle verbergen',
	actualData: 'Ist-Daten',
	deleteBackpack: 'Rucksack löschen',
	chooseMasterData: 'Stammdaten auswählen',
	chooseSource: 'Quelle auswählen',
	enterSourceName: 'Quellenname eingeben',
	exportVisibleMaterialOnly: 'Nur sichtbare Materialien exportieren',
	alsoExportFuturesContracts: 'Auch Terminkontrakte exportieren',
	exportCsv: 'Als CSV exportieren',
	exportExcel: 'Als Excel exportieren',
	devices: 'Geräte',
	lastLogin: 'Letzter Log-in',
	minutes: 'Minuten',
	dailyActiveUsers: 'Tägliche aktive User',
	weeklyActiveUsers: 'Wöchentliche aktive User',
	monthlyActiveUsers: 'Monatliche Aktive User',
	totalUsers: 'User gesamt',
	newUsers: 'Neue User',
	averageTimeSpend: 'Durchschnittliche Nutzungsdauer',
	averagePageVisits: 'Durchschnittliche Seitenaufrufe',
	downloadFilesheet: 'Tabellen-Downloads',
	currencies: 'Währungen',
	units: 'Einheiten',
	countriesAndRegions: 'Länder und Regionen',
	notations: 'Notierungen',
	tendersCountries: 'Ausschreibungsländer',
	askMeSomething: 'Frag mich etwas',
	logins: 'Anmeldungen',
	customerSince: 'Kunde seit',
	freemiumSince: 'Freemium seit',
	language: 'Sprache',
	triggered: 'Eingetreten',
	newsAlert: 'Nachrichten-Alert',
	tenderAlert: 'Ausschreibungen-Alert',
	projectAlert: 'Projektfrühinformationen Alert',
	priceAlert: 'Kurs-Alert',
	and: '+ UND',
	or: '/ ODER',
	latestNewsAlert: 'Neueste Nachrichten Alert',
	latestTendersAlert: 'Neueste Ausschreibungen Alert',
	categories: 'Kategorien',
	alreadyAddedDashboard: 'Dashboard bereits hinzugefügt!',
	latestPJEAlert: 'Neueste PJE Alert',
	comparison: 'Vergleich',
	startDate: 'Startdatum',
	endDate: 'Enddatum',
	invalidFileTypeMessage: 'Bitte laden Sie die CSV- oder XLXS-Datei hoch.',
	dataUpload: 'Daten-Upload',
	errors: 'Fehler',
	newsAlertValidation: 'Es ist entweder ein Schlüsselwort oder eine Kategorie erforderlich!',
	atLeastOneFieldRequired: 'Mindestens ein Feld ist erforderlich!',
	eexForecast: 'EEX Prognose',
	mbiForecast: 'MBI Prognose',
	changeCurrency: 'Umrechnen',
	materialGroup: 'Material Gruppe',
	enterCorrectEmailAddress: 'Bitte eine korrekte Email-Adresse angeben',
	reqNewPasswordText:
		'Wenn Sie ein neues Passwort anfordern, erhalten Sie von uns eine E-Mail mit einem Link zum Einrichten eines neuen Passworts.',
	reqNewPassword: 'Neues Passwort anfordern',
	alreadyRegisteredText: 'Wenn Sie bereits registriert sind, melden Sie sich',
	an: 'an',
	notASubscriberText: 'Sie sind noch kein Abonnent?',
	forgotPasswordRegister: 'registrieren',
	forgotPasswordNow: 'Jetzt',
	trayMatflixxForFree: 'und Matflixx kostenlos testen.',
	knownEmailAddressText:
		'Wenn Ihre E-Mail-Adresse bekannt ist, erhalten Sie in den nächsten Minuten eine E-Mail von uns. Sollten Sie nach 5 Minuten keine E-Mail erhalten haben, prüfen Sie bitte auch Ihren Spam-Ordner. Alternativ können Sie sich auch an den Kundenservice wenden',
	priceUpdate: 'Preisaktualisierungen',
	newPrice: 'Neue Preise',
	masterDataUpdate: 'Stammdatenaktualisierungen',
	newMasterData: 'Neue Stammdaten',
	includeForecast: 'Prognose einbeziehen',
	include: 'einschließen',
	exclude: 'ausschließen',
	errorOne: 'Problem mit der Spaltenüberschrift, könnte durch einen Tippfehler verursacht werden, z.B. "simbol" statt "symbol".',
	errorTwo: 'Kritischer Eintrag fehlt. Kritische Einträge: symbol; boerse.',
	errorThree: 'Datumsformat stimmt nicht mit den erlaubten Datumsformaten überein.',
	errorFour: 'Das Zahlenformat kann nicht verarbeitet werden, z.B. wenn der Eintrag nicht nur Zahlen enthält..',
	errorFive: 'Dateiname kann vom System nicht verarbeitet werden',
	errorSix: 'Dateityp kann vom System nicht verarbeitet werden',
	errorSeven: 'Die Währung ist kein Eintrag im Währungsblatt',
	errorEight: 'Einheit ist kein Eintrag im Einheitenblatt',
	errorNine: 'Wert überschreitet %-Änderungswert',
	start: 'Start',
	end: 'End',
	unKnownError: 'Unbekannter Fehler',
	advanceSearchText: 'Suche in Datenbank nach Ergebnissen',
	lockForecastText: 'Um Prognosen einzusehen, bitte an den Kundenservice wenden',
	currencyDefaultTooltipMessage: 'Für die Standard-Währungsumrechnung verwenden wir die Forex Werte',
	currencyBloombergTooltipMessage: 'Für Bloomberg bieten wir lediglich den EUR/USD Fixing Frankfurt 14.00 Uhr, BFIX Kurs an',
	currencyTooltipMessage:
		'Sollten Sie einen anderen Wechselkurs anwenden wollen, wählen Sie in den Erweiterten Einstellungen die gewünschte Quelle aus',
	lme: 'LME',
	bloomberg: 'Bloomberg',
	ecb: 'EZB',
	currencyConversion: 'Währungs-Umrechnung',
	chartView: 'Chart Ansicht',
	categoryInfo:
		'Legen Sie eine spezifische Nachrichtenkategorie fest, um die Trefferquote zu erhöhen. Falls keine Kategorie ausgewählt wird, erfolgt die Suche in allen Kategorien. Wählen Sie danach ggf. weitere Kategorien aus. Zur Auswahl steht Ihnen dann die “UND” oder “ODER” Suche. Klicken Sie auf das Wort “UND” bzw. “ODER”, um den Suchmodus zu ändern.',
	countryInfo:
		'Wählen Sie die Länder aus, für die Ihre Alerts relevant sein sollen. Nur Treffer aus diesen Ländern werden in Ihre Benachrichtigungen aufgenommen. Wählen Sie danach ggf. weitere Länder aus. Zur Auswahl steht Ihnen dann die “UND” oder “ODER” Suche. Klicken Sie auf das Wort “UND” bzw. “ODER”, um den Suchmodus zu ändern.',
	sectorInfo:
		'Legen Sie fest, welche Sektoren oder Branchen für Ihre Alerts berücksichtigt werden sollen. So erhalten Sie gezielte Benachrichtigungen zu relevanten Themen. Wählen Sie danach ggf. weitere Sektoren aus. Zur Auswahl steht Ihnen dann die “UND” oder “ODER” Suche. Klicken Sie auf das Wort “UND” bzw. “ODER”, um den Suchmodus zu ändern.',
	financersInfo:
		'Tragen Sie die Namen der finanzierenden Länder oder Organisationen ein, nach denen Ihre Alerts gefiltert werden sollen. Dies ermöglicht eine präzisere Auswahl passender Ausschreibungen oder Nachrichten. Wählen Sie danach ggf. weitere Finanzierer aus. Zur Auswahl steht Ihnen dann die “UND” oder “ODER” Suche. Klicken Sie auf das Wort “UND” bzw. “ODER”, um den Suchmodus zu ändern.',
	keyWordInfo:
		'Definieren Sie ein oder mehrere freie Suchwörter. Klicken Sie nach jedem Suchwort die Entertaste und geben Sie danach ggf. weitere Suchwörter ein. Zur Auswahl steht Ihnen dann die “UND” oder “ODER” Suche. Klicken Sie auf das Wort “UND” bzw. “ODER”, um den Suchmodus zu ändern.',
	timeInfo: 'Uhrzeit, an welcher die Alerts verschickt werden.',
	andOperator: 'UND',
	orOperator: 'ODER',
	nameInfo: 'Wählen Sie einen aussagekräftigen Namen für Ihren Alert. Dieser wird auch in den E-Mail-Benachrichtigungen verwendet.',
	courseAlertTitle: 'MATFLIXX Kurs-Alert',
	courseAlertGlance: 'Ihre persönlichen Kurs-Alerts auf einen Blick',
	courserDescription: 'Auf dieser Seite sehen Sie alle Ihre individuellen Kurs-Alerts. Behalten Sie',
	courseMarket: 'Marktpreise und Marktbewegungen',
	courseChange: 'jederzeit im Blick und reagieren Sie sofort auf Preisänderungen.',
	customizable: 'Individuell anpassbar',
	automaticNotifications: 'Automatische Benachrichtigung',
	efficientMarketMonitoring: 'Effiziente Marktüberwachung',
	courseAdvantage: 'Ihr Vorteil: Reagieren Sie schnell auf Schwankungen und sichern Sie sich die besten Konditionen.',
	courseAlertStep: 'So richten Sie einen MATFLIXX Kurs-Alert ein',
	courseStepOne: 'Zur Chartingseite navigieren – ',
	courseStepOneDescription: 'Öffnen Sie die Grafik des gewünschten Preises auf MATFLIXX.',
	courseStepTwo: '„Kurs-Alert einrichten" anklicken – ',
	courseStepTwoDescription: 'Diese Schaltfläche befindet sich unten links unter der Grafik.',
	courseStepThree: 'Vergleichswert wählen – ',
	courseStepThreeDescription: 'Bestimmen Sie den Preis, bei dem Sie benachrichtigt werden möchten.',
	courseStepFour: 'Benachrichtigung erhalten – ',
	courseStepFourDescription: 'Sobald der Preis Ihr definiertes Niveau erreicht, erhalten Sie eine E-Mail direkt in Ihr Postfach.',
	courseStepFive: 'Alerts jederzeit bearbeiten oder löschen – ',
	courseStepFiveDescription: ' Navigieren Sie in der Menüführung zu "Alerts".',
	courseAlertStayUp: 'Bleiben Sie immer auf dem neuesten Stand – mit dem MATFLIXX Kurs-Alert!',
	contactUsAndFeedback: 'Bei Fragen stehen wir Ihnen gerne zur Verfügung und freuen uns auf Ihr Feedback.',
	newsAlertTitle: 'MATFLIXX Nachrichten-Alert',
	newsAlertGlance: 'Ihre persönlichen Nachrichten-Alerts auf einen Blick',
	newsDescription: 'Auf dieser Seite sehen Sie alle Ihre individuellen',
	newsMarket: 'News-Alerts',
	newsChange: 'und können diese hier auch direkt einrichten. Bleiben Sie über ',
	newsSales: 'Marktentwicklungen, Branchentrends und wichtige Nachrichten',
	allTimes: 'jederzeit informiert.',
	newsAlertAdvantage: 'Ihr Vorteil: Reagieren Sie schnell auf wichtige Entwicklungen und treffen Sie fundierte Entscheidungen.',
	newsAlertStep: 'So richten Sie einen MATFLIXX Nachrichten-Alert ein',
	directlyOnThisPage: 'Direkt auf dieser Seite:',
	newsStepOne: '"+ Neuer Alert" klicken',
	newsStepTwo: 'Einstellungen festlegen – ',
	newsStepTwoDescription:
		'Legen Sie einen Namen für Ihren neuen Alert fest. Dieser erscheint in Ihrer Benachrichtigungsemail. Wählen Sie Suchworte bzw. Kategorien ("UND" bzw "ODER" Suche möglich), sowie den Versandzeitpunkt aus. Ohne Zeitangabe erhalten Sie neue Alerts einzeln sofort per E-Mail.',
	whenReadingAnArticle: 'Beim Lesen eines Artikels:',
	newsStepThree: 'Button "((!))" klicken – ',
	newsStepThreeDescription: 'Nutzen Sie den blauen Alert-Button rechts über einem Artikel.',
	newsStepFourDescription:
		'Legen Sie einen Namen für Ihren neuen Alert fest. Dieser erscheint in Ihrer Benachrichtigungsemail. Die Kategorien des jeweiligen Artikels sind bereits vorselektiert. Sie können Kategorien abwählen. Wählen Sie weitere Suchworte bzw. Kategorien ("UND" bzw "ODER" Suche möglich), sowie den Versandzeitpunkt aus. Ohne Zeitangabe erhalten Sie neue Alerts einzeln sofort per E-Mail.',
	newsNote: '💡 Tipp: Sie können mehrere Alerts erstellen, indem Sie den Vorgang beliebig oft wiederholen.',
	newsStayUp: 'Bleiben Sie bestens informiert – mit dem MATFLIXX Nachrichten-Alert!',
	tenderAlertTitle: 'MATFLIXX Ausschreibungs-Alert',
	pjeAlertTitle: 'MATFLIXX Projektfrühinformations-Alert',
	tenderGlance: 'Ihre individuellen Alerts auf einen Blick',
	tenderDescription:
		'Behalten Sie den Überblick über aktuelle Investitions- und Entwicklungsprojekte sowie internationale Ausschreibungen. Dank personalisierter Benachrichtigungen erhalten Sie relevante Informationen direkt per E-Mail – inklusive weiterführender Kontaktadressen und Ansprechpartner.',
	tenderAdvantage: '📩 Immer einen Schritt voraus – mit den MATFLIXX Projektfrühinformationen & Auslandsausschreibungen-Alerts!',
	tenderAlertStep: 'So richten Sie Ihren Alert ein',
	tenderStepTwoDescription:
		'Legen Sie einen Namen für Ihren neuen Alert fest. Dieser erscheint in Ihrer Benachrichtigungsemail. Wählen Sie Länder, Sektoren, Finanzierer und Suchworte ("UND" bzw "ODER" Suche möglich), sowie den Versandzeitpunkt aus. Ohne Zeitangabe erhalten Sie neue Alerts einzeln sofort per E-Mail.',
	tenderStepThree: 'Hinzufügen – ',
	tenderStepThreeDescription: 'Sie werden per Email und durch einen orangefarbigen Punkt in Matflixx  informiert.',
	whenReadingTenderText: 'Beim Lesen eines Ausschreibungstextes/ Projektfrühinformation:',
	tenderStepOneReading: 'Eine beliebige ',
	tenderStepOneReadingDescription: 'Ausschreibung oder Projektfrühinformation öffnen .',
	tenderStepTwoReadingDescription: 'Nutzen Sie den blauen Alert-Button rechts oben über einem Artikel.',
	tenderStepThreeReadingDescription:
		'Legen Sie einen Namen für Ihren neuen Alert fest. Dieser erscheint in Ihrer Benachrichtigungsemail. Länder, Sektoren und Finanzieren sind bereits vorausgewählt. Sie können diese bei Bedarf löschen oder ändern  (""UND"" bzw ""ODER"" Suche möglich). Suchwörter und den Versandzeitpunkt ergänzen Sie zusätzlich. Ohne Zeitangabe erhalten Sie neue Alerts einzeln sofort per E-Mail.',
	biMonthly: 'Zwei-monatlich',
	biWeekly: 'Zwei-wöchentlich',
	continually: 'Kontinuierlich',
	halfYearly: 'Halbjährlich',
	irregular: 'Unregelmäßig',
	costModel: 'Kostenmodelle',
	current: 'Aktuell',
	historic: 'Historisch',
	addCostModelToOverview: 'Kostenmodell zur Übersicht hinzufügen',
	exportCostModel: 'Kostenmodell exportieren',
	copyToMyModels: 'Zu meinen Modellen kopieren',
	addCostModel: 'Kostenmodell hinzufügen',
	addToMyModels: 'Zu meinen Modellen hinzufügen',
	adminDownload: 'Admin-Download',
	assignModelToAUser: 'Modell einem Benutzer zuweisen',
	deleteCostModel: 'Kostenmodell löschen',
	costModelSupportText: 'Sie haben keinen Platz mehr für ein Kostenmodell. Bitte löschen Sie ein Modell oder kontaktieren Sie den Kundensupport.',
	createAsMatflixxModel: 'Als Matflixx-Modell erstellen',
	displayName: 'Anzeigename',
	rawMaterial: 'Rohmaterial',
	type: 'Typ',
	period: 'Zeitraum',
	german: 'Deutsch',
	english: 'Englisch',
	priority: 'Priorität',
	successfullyAddedCostModelToDashboard: 'Kostenmodell erfolgreich zum Dashboard hinzugefügt',
	successfullyCopiedCostModelToMyModels: 'Kostenmodell erfolgreich in meine Modelle kopiert',
	successfullyDeletedCostModel: 'Kostenmodell erfolgreich gelöscht',
	deleteModel: 'Modell löschen',
	createANewCostModel: 'Neues Kostenmodell erstellen',
	areYouSureYouWantToDeleteYourCostModel: 'Sind Sie sicher, dass Sie Ihr Kostenmodell "{{name}}" löschen wollen?',
	confirmDelete: 'Zum bestätigen geben Sie bitte den namen Ihres<br /> Modells ein und klicken SIe auf löschen',
	areYouSureThatYourCostModel: 'Sind Sie sicher, dass Sie Ihr Kostenmodell:',
	wantToDelete: 'löschen wollen?',
	modifyModel: 'Um dieses Modell zu ändern, müssen Sie es in Ihre Modelle kopieren',
	copyModel: 'Modell kopieren',
	spaces: 'Plätze',
	pleaseContactCustomerSupportToUnlockThisElement: 'Bitte kontaktieren Sie den Kundensupport, um dieses Element freizuschalten',
	pleaseSelectValidMaterial: 'Bitte wählen Sie ein gültiges Material',
	deleteModalPlaceholder: 'Namen des Models',
	internalServerError: 'Internal server error',
	noSpaceError: 'Kein Platz verfügbar',
	modelSettings: 'Modelleinstellungen',
	addMatflixxCostModel: 'Matflixx-Kostenmodell hinzufügen',
	generalSettings: 'Allgemeine Einstellungen',
	dateFormat: 'Datumsformat',
	decimalSeparator: 'Dezimaltrenner',
	defaultChartType: 'Standard Chart-Typ:',
	surface: 'Flächen-Chart',
	lines: 'Linien-Chart',
	barChart: 'Balken-Chart',
	defaultChartColor: 'Standard Chart-Farbe:',
	forex: 'Forex',
	uploadFileMessage: 'Sind Sie sicher, dass Sie Datei hochladen?',
	deleteNewsCategoryMessage: 'Sind Sie sicher, dass Sie dieses Objekt löschen möchten?',
	noSpaceAvailable: 'Sie haben keinen Platz mehr für ein Kostenmodell.',
	contactCustomerSupport: 'Bitte kontaktieren Sie den Kundensupport',
	authorization: 'Authorization',
	massAuthorization: 'Massenautorisierung',
	orDragAndDropHere: 'oder hierher ziehen',
	percentageChangeSingle: '%-Verändeurng (Einzel)',
	percentageChangeTotal: '%-Verändeurng (Gesamt)',
	quaterly: 'quartalsweise',
	carryForward: 'Carry Forward',
	includeWeekends: 'Wochenenden einschließen',
	advanceMaterialCourseTime: 'Kurszeit',
	original: 'Original',
	thisMaterialCannotBeAddedToCostModel: 'Dieses Material kann leider nicht zu einem Kostenmodell hinzugefügt werden.',
	carryForwardYesInfo: 'Leere Daten zwischen vorhandenen Datenpunkten werden mit zuvor vorhandenen Werten aufgefüllt',
	carryForwardNoInfo: 'Es werden nur vorhandene Datenpunkte exportiert',
	includesWeekendYesInfo: 'Daten, die an einem Wochenende aktualisiert werden, werden exportiert',
	includesWeekendNoInfo: 'Neue Daten, die an einem Wochenende aktualisiert werden, werden nicht exportiert',
	includesForecastYesInfo: 'Prognosedatenpunkte werden in den Export aufgenommen und in Abbildungen angezeigt',
	includesForecastNoInfo: 'Prognosedatenpunkte werden aus dem Export ausgeschlossen und nicht in Abbildungen angezeigt',
	errorMessageForChartCheckbox: 'Es muss mindestens ein Datenpunkt ausgewählt sein..',
	errorMessageForChartTypeSelection: 'Bitte ändern Sie den Chart-Typ, um weitere Preise hinzuzufügen.',
	uploadErrorMessage: 'Bitte wählen Sie eine Datei mit Namen "Matflixx_Berechtigungen" aus',
	course: 'Kurs',
	courseTooltipText: 'Auswahl der im Charting anzuzeigenden Daten.',
	frequencyTooltipText: 'Intervall zwischen Dateneinträgen'
};
